interface BuildUpdateBannerProps {
  isApplyingUpdate: boolean;
  onApplyUpdate: () => void;
}

const bannerCardStyle = {
  backdropFilter: "blur(12px)",
  background:
    "linear-gradient(135deg, rgba(255,255,255,0.96), rgba(248,250,252,0.94))",
  border: "1px solid rgba(148, 163, 184, 0.28)",
  borderRadius: "24px",
  boxShadow: "0 20px 60px rgba(15, 23, 42, 0.18)",
};

const iconStyle = {
  background: "rgba(59, 130, 246, 0.12)",
  color: "#1d4ed8",
  height: "44px",
  width: "44px",
};

const buttonStyle = {
  background: "#111827",
  border: "none",
  borderRadius: "999px",
  minHeight: "44px",
  padding: "0 20px",
};

const BuildUpdateBanner = (props: BuildUpdateBannerProps) => {
  return (
    <div className="position-fixed top-0 start-0 end-0 px-3 pt-3" style={{ zIndex: 2000 }}>
      <div className="container-fluid px-0">
        <div
          className="mx-auto d-flex flex-column gap-3 p-4 p-md-4"
          style={{
            ...bannerCardStyle,
            maxWidth: "1100px",
          }}
        >
          <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-md-between gap-3">
            <div className="d-flex align-items-start gap-3">
              <div
                className="d-inline-flex align-items-center justify-content-center flex-shrink-0 rounded-circle"
                style={iconStyle}
              >
                <svg
                  aria-hidden="true"
                  fill="none"
                  height="20"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.8"
                  viewBox="0 0 24 24"
                  width="20"
                >
                  <path d="M21 12a9 9 0 1 1-2.64-6.36" />
                  <path d="M21 3v6h-6" />
                </svg>
              </div>

              <div>
                <div className="fw-semibold text-dark">
                  Une mise a jour de l&apos;application est disponible
                </div>
                <div className="mt-1 text-secondary">
                  Rechargez l&apos;application pour utiliser la derniere version.
                </div>
              </div>
            </div>

            <button
              className="btn text-white fw-medium"
              disabled={props.isApplyingUpdate}
              onClick={props.onApplyUpdate}
              style={buttonStyle}
              type="button"
            >
              {props.isApplyingUpdate
                ? "Mise a jour en cours..."
                : "Mettre a jour maintenant"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuildUpdateBanner;
